import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { ProductDetailsDto } from '../dtos';

export enum SelectProductActionTypes {
  GetProductDetails = '[SelectProduct] GetProductDetails',
  GetProductDetailsSuccess = '[SelectProduct] GetProductDetailsSuccess',
  GetProductDetailsError = '[SelectProduct] GetProductDetailsError',
  ProductBarcodeScanned = '[SelectProduct] ProductBarcodeScanned',
}

export const getProductDetailsAction = createAction(SelectProductActionTypes.GetProductDetails, props<{ barcode: string }>());
export const getProductDetailsSuccessAction = createAction(
  SelectProductActionTypes.GetProductDetailsSuccess,
  props<{ productDetails: ProductDetailsDto }>()
);
export const getProductDetailsErrorAction = createAction(
  SelectProductActionTypes.GetProductDetailsError,
  props<{ failure: AppStateFailure }>()
);
export const productBarcodeScannedAction = createAction(SelectProductActionTypes.ProductBarcodeScanned, props<{ barcode: string }>());
